import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { SiteProvider } from "../lib/SiteContext";
import usePageTracking from "../hooks/usePageTracking";

function Layout() {
  const location = useLocation();

  // Record the page view for the admin analytics screen.
  usePageTracking();

  // Start each page at the top, the way a normal page load would.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <main>
      <div className="">
        <Navbar />
        <div className="">
          <Outlet />
        </div>
        <Footer />
      </div>
    </main>
  );
}

export default function Root() {
  return (
    <SiteProvider>
      <Layout />
    </SiteProvider>
  );
}
